<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em;">T.D. Holmes is a British author based in Northern Ireland, UK. Despite being dyslexic, she loves to read and after a traumatic experience, found solace in writing. Since then, her love for writing grew as she discovered a creative and vivid imagination.</p><br/>
<p style="text-indent:0em;">She describes herself as nerdy with a sarcastic sense of humour. She loves everything Disney and sci-fi. From <em>Doctor Who</em> to <em>Marvel</em> and <em>DC</em>. She has a great love of foxes and dreams to start a conservation charity.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?085ed8f6